export const LookingForSomethingDifferentComponent = () => null;